<div class="At-ProfileContacts">
  <div class="At-ProfileTabContent">
    <tabset>
      <tab heading="all contacts" id="tab1">
        <div class="At-ProfileContactsContent">
          <ul class="At-InformationList">
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/members/member-img09.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Aiman .<span> minu </span></h5>
                      <h6>Last Seen yesterday</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure>
                    <img src="assets/images/members/member-img05.png" alt="" class="img-fluid">
                    <div class="At-badgePurple"><i class="icon-bage"></i></div>
                  </figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Anatoli . <span class="At-TextPurple">matt</span> . <span class="At-TextPurple">Project Manager</span></h5>
                      <h6>Last Seen 19th Aug, 2020</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/profile/profile-small3.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Betty S. . <span>starnot</span></h5>
                      <h6>Last Seen 5 mins ago</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/members/member-img03.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Jacob_98 . <span> jazzy</span></h5>
                      <h6>Last Seen yesterday</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure>
                    <img src="assets/images/members/member-img01.png" alt="" class="img-fluid">
                    <div class="At-badgePurple"><i class="icon-bage"></i></div>
                  </figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Julian . <span class="At-TextRedLight"> jona</span> . <span class="At-TextRedLight"> coo</span></h5>
                      <h6>14 hours ago</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/members/member-img04.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Lara . <span>lolpop</span></h5>
                    <h6>Last Seen yesterday</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/profile/profile-small5.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Manuel . <span>cruser</span></h5>
                      <h6>Last Seen yesterday</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/members/member-img09.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Nattalia .<span> nats </span></h5>
                      <h6>Last Seen yesterday</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/profile/profile-small3.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Selina .<span> sassy </span></h5>
                      <h6>Last Seen yesterday</h6>
                  </div>
                  <div class="At-TitleRight">
                    <i class="icon-more"></i>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </tab>
      <tab heading="follow requests">
        <div class="At-ProfileContactsContent">
          <ul class="At-InformationList">
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/profile/profile-small3.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Ainita <span class="At-TextDarkGrey2">send you a follow request</span></h5>
                      <h6>4 hours ago</h6>
                  </div>
                  <div class="At-BtnArea">
                    <Button class="mr-4">Accept</Button>
                    <Button class="At-BgRed">Decline</Button>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/members/member-img03.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Fernando <span class="At-TextDarkGrey2">send you a follow request</span></h5>
                      <h6>22 hours ago</h6>
                  </div>
                  <div class="At-BtnArea">
                    <Button class="mr-4">Accept</Button>
                    <Button class="At-BgRed">Decline</Button>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/members/member-img04.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Farah <span class="At-TextDarkGrey2">send you a follow request</span></h5>
                      <h6>1 day ago</h6>
                  </div>
                  <div class="At-BtnArea">
                    <Button class="mr-4">Accept</Button>
                    <Button class="At-BgRed">Decline</Button>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="At-InfoBox">
                <div class="At-InfoImg">
                  <figure><img src="assets/images/profile/profile-small5.png" alt="" class="img-fluid"></figure>
                </div>
                <div class="At-InfoTitle d-flex">
                  <div class="At-TitleLeft">
                    <h5>Nathan <span class="At-TextDarkGrey2">send you a follow request</span></h5>
                      <h6>1 day ago</h6>
                  </div>
                  <div class="At-BtnArea">
                    <Button class="mr-4">Accept</Button>
                    <Button class="At-BgRed">Decline</Button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </tab>
    </tabset>
  </div>
</div>
